function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 33.5,
  r: 33.5,
  fill: "#3498FE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.016 22.86l-.978.93c-.195.245-.195.636 0 .832l8.85 8.854-8.85 8.903c-.195.195-.195.587 0 .831l.978.93a.562.562 0 00.831 0l10.267-10.224a.663.663 0 000-.832L31.847 22.86a.563.563 0 00-.83 0z",
  fill: "#fff"
});

function SvgSelectRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjcgNjciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSIzMy41IiBjeT0iMzMuNSIgcj0iMzMuNSIgZmlsbD0iIzM0OThGRSIgLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTMxLjAxNjEgMjIuODYwNEwzMC4wMzgzIDIzLjc4OTlDMjkuODQyNyAyNC4wMzQ1IDI5Ljg0MjcgMjQuNDI1OCAzMC4wMzgzIDI0LjYyMTVMMzguODg3NCAzMy40NzU2TDMwLjAzODMgNDIuMzc4N0MyOS44NDI3IDQyLjU3NDMgMjkuODQyNyA0Mi45NjU3IDMwLjAzODMgNDMuMjEwM0wzMS4wMTYxIDQ0LjEzOTdDMzEuMjYwNSA0NC4zODQzIDMxLjYwMjggNDQuMzg0MyAzMS44NDcyIDQ0LjEzOTdMNDIuMTE0MiAzMy45MTU5QzQyLjMwOTcgMzMuNjcxMyA0Mi4zMDk3IDMzLjMyODkgNDIuMTE0MiAzMy4wODQzTDMxLjg0NzIgMjIuODYwNEMzMS42MDI4IDIyLjYxNTkgMzEuMjYwNSAyMi42MTU5IDMxLjAxNjEgMjIuODYwNFoiCiAgICAgICAgZmlsbD0id2hpdGUiIC8+Cjwvc3ZnPgogICAg";
export { SvgSelectRight as ReactComponent };